import { ELoginAs } from './types';

export const SWITCH_ACCOUNT_KEY = 'switch_account';

export const DEMO_LOGINS = [ELoginAs.MT4_DEMO, ELoginAs.MT5_DEMO, ELoginAs.OMS_DEMO, ELoginAs.CENTROID_DEMO];

export const DEMO_LOGINS_WITHOUT_OMS = [ELoginAs.MT4_DEMO, ELoginAs.MT5_DEMO, ELoginAs.CENTROID_DEMO];

export const LIVE_LOGINS = [
  ELoginAs.LIVE,
  ELoginAs.MT4_LIVE,
  ELoginAs.MT5_LIVE,
  ELoginAs.OMS_LIVE,
  ELoginAs.CENTROID_LIVE
];

export const LIVE_LOGINS_WITHOUT_CRM = [
  ELoginAs.MT4_LIVE,
  ELoginAs.MT5_LIVE,
  ELoginAs.OMS_LIVE,
  ELoginAs.CENTROID_LIVE
];

export const LIVE_LOGINS_WITHOUT_CRM_AND_OMS = [ELoginAs.MT4_LIVE, ELoginAs.MT5_LIVE, ELoginAs.CENTROID_LIVE];

export const MT_LIVE_CONFIGS = [ELoginAs.MT4_LIVE, ELoginAs.MT5_LIVE];
